import React from "react";

const PdfIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2069_636)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3.31982,
  y: 3.34003,
  width: 33.34,
  height: 33.34,
  rx: 4,
  fill: "#F05C5C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.2213 22.9948C29.6353 22.3438 28.3332 22.0183 26.5754 22.0183C25.5338 22.0183 24.427 22.1485 23.1249 22.3438C21.7462 21.0524 20.6009 19.5327 19.7395 17.8516C20.3905 15.8985 20.8463 14.0104 20.8463 12.5781C20.8463 11.4714 20.4556 9.71356 18.8931 9.71356C18.4374 9.71356 18.0468 9.97398 17.7864 10.3646C17.1353 11.5365 17.3957 14.1406 18.6327 16.875C17.7291 19.4879 16.6413 22.0333 15.3775 24.4922C11.927 25.9245 9.64835 27.487 9.45303 28.724C9.32282 29.3099 9.71345 30.2865 11.0806 30.2865C13.0989 30.2865 15.3124 27.3568 17.0051 24.362C18.9591 23.6901 20.9614 23.1677 22.9947 22.7995C25.4687 24.9479 27.6171 25.2735 28.6588 25.2735C30.7421 25.2735 30.9374 23.7761 30.2213 22.9948ZM18.1119 10.5599C18.6327 9.77867 19.8046 10.0391 19.8046 11.6016C19.8046 12.6432 19.4791 14.336 18.828 16.2891C17.6562 13.5547 17.6562 11.4063 18.1119 10.5599ZM9.84366 28.7891C10.039 27.7474 11.9921 26.3151 15.052 25.0781C13.3593 27.9427 11.6666 29.7656 10.6249 29.7656C9.97387 29.7656 9.77855 29.1797 9.84366 28.7891ZM22.6692 22.4089C20.8347 22.7507 19.0285 23.2295 17.2655 23.8412C18.2291 22.1019 19.0144 20.2697 19.6093 18.3724C20.465 19.8349 21.4922 21.19 22.6692 22.4089ZM23.5155 22.6693C25.5989 22.3438 27.3567 22.4089 28.1379 22.5391C30.026 22.9297 29.3749 25.2084 27.2916 24.6875C25.7942 24.362 24.5572 23.5156 23.5155 22.6693Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2069_636"
}, /*#__PURE__*/React.createElement("rect", {
  width: 33.3333,
  height: 33.3333,
  fill: "white",
  transform: "translate(3.33325 3.33334)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(PdfIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;